// Simplified SurveyAnswer.jsx - Now just handles question type routing
import React from 'react';
import SurveyRenderer from './SurveyRenderer'; // Import the new SurveyRenderer component

const SurveyAnswer = ({
  questionText,
  questionType,
  surveyQuestionId,
  surveyAnswer,
  selectedExcerptId,
  select,
  onParagraphClick,
  onTitleClick,
  logo,
  color,
  hasEditPermission,
  page
}) => {
  // Handle paragraph click with survey-specific parameters
  const handleParagraphClick = (start, end, transcriptId) => {
    if (onParagraphClick) {
      onParagraphClick(start, end, surveyAnswer?.id, surveyQuestionId);
    }
  };

  if (questionType === 'text' && surveyAnswer?.body) {
    return (
      <SurveyRenderer
        transcriptId={surveyAnswer?.id}
        transcriptText={surveyAnswer?.body}
        selectedExcerptId={selectedExcerptId}
        select={select}
        page={page}
        onParagraphClick={handleParagraphClick}
        onTitleClick={onTitleClick}
        questionText={questionText}
        logo={logo}
        color={color}
        hasEditPermission={hasEditPermission}
      />
    );
  }

  if (questionType === 'single_choice') {
    return (
      <div>
        {surveyAnswer?.survey_option?.option_text || 'No answer provided'}
      </div>
    );
  }

  return <div>No answer provided</div>;
};

export default SurveyAnswer;